import type { AmountRange } from "components/common/AmountRangeChip";

/** The `transactions` query's amount input: a range of sizes, so money in and money out both match it. */
export const amountQuery = ({ min, max }: AmountRange = {}) =>
  min !== undefined || max !== undefined
    ? { less: min, greater: max, absolute: true }
    : undefined;
